import Vue from 'vue';
import Vuex from 'vuex';
import {VueApp} from '@/main';

export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_RESET = "LOGIN_RESET";
export const PROFILE = "PROFILE";
export const LOGOUT = "LOGOUT";
export const MAIN_LOADING = "MAIN_LOADING";
export const SIDEBAR_TOGGLE = "SIDEBAR_TOGGLE";
export const SIDEBAR_TOGGLE_MINI = "SIDEBAR_TOGGLE_MINI";
export const SIDEBAR_TOGGLE_MOBILE = "SIDEBAR_TOGGLE_MOBILE";

Vue.use(Vuex);

const AppStore = new Vuex.Store({
    state: {
        profile: {},
        isAdmin: false,
        mainLoading: false,
        isLoggedIn: false,
        loginProgress: false,
        loginError: '',
        sidebar: {
            open: true,
            mini: true,
            mobile: false
        }
    },
    mutations: {
        [LOGIN](state) {
            state.loginProgress = true;
        },
        [LOGIN_SUCCESS](state) {
            state.loginProgress = false;
            state.isLoggedIn = true;
        },
        [LOGIN_FAILURE](state) {
            state.loginProgress = false;
            state.isLoggedIn = false;
            state.loginError = 'Имя пользователя и / или пароль недействительны';
        },
        [LOGIN_RESET](state) {
            state.loginError = '';
        },
        [LOGOUT](state) {
            state.isLoggedIn = false;
            state.profile = {};
            state.isAdmin = false;
        },
        [PROFILE](state, payload) {
            state.isLoggedIn = true;
            state.profile = payload;
            state.isAdmin = false;
            if (state.profile && state.profile.roles && state.profile.roles.length > 0) {
                for (const role of state.profile.roles) {
                    if (role === 'ROLE_ADMIN') {
                        state.isAdmin = true;
                    }
                }
            }
        },
        [MAIN_LOADING](state, loading) {
            state.mainLoading = loading;
        },
        [SIDEBAR_TOGGLE](state) {
            state.sidebar.open = !state.sidebar.open;
        },
        [SIDEBAR_TOGGLE_MINI](state) {
            state.sidebar.mini = !state.sidebar.mini;
        },
        [SIDEBAR_TOGGLE_MOBILE](state) {
            state.sidebar.mobile = !state.sidebar.mobile;
        }
    },
    actions: {
        logIn({commit, dispatch}, creds) {
            commit(LOGIN); // show spinner
            return new Promise(resolve => {
                VueApp.$http.post('login', creds)
                    .then(res => {
                        this.loading = false;
                        res = res.data;
                        if (res.status && res.status === 'SUCCESS') {
                            localStorage.setItem('x_token', res.data.token);
                            commit(LOGIN_SUCCESS);
                            VueApp.$router.push('/category');
                            dispatch('initProfile', false);
                        } else {
                            commit(LOGIN_FAILURE);
                        }
                        resolve();
                    }, err => {
                        console.log(err);
                        commit(LOGIN_FAILURE);
                        resolve();
                    });
            });
        },
        logInReset({commit}) {
            commit(LOGIN_RESET);
        },
        logOut({commit}) {
            localStorage.removeItem("x_token");
            commit(LOGOUT);
        },
        initProfile({commit}, redirect) {
            const token = localStorage.getItem('x_token');
            if (token && token.length > 0) {
                VueApp.$http.get('profile')
                    .then(res => {
                        res = res.data;
                        if (res.id && res.id > 0) {
                            commit(PROFILE, res);
                            if (redirect) {
                                const path = window.location.pathname;
                                if (!path || path === '' || path === '/') {
                                    VueApp.$router.push('/category');
                                }
                            }
                        } else if (redirect) {
                            VueApp.$router.push('/');
                        }
                        commit(MAIN_LOADING, false);
                    }, err => {
                        console.log(err);
                    });
            } else {
                commit(MAIN_LOADING, false);
            }
        },
        sideBarToggle({commit}) {
            commit(SIDEBAR_TOGGLE);
        },
        sideBarToggleMini({commit}) {
            commit(SIDEBAR_TOGGLE_MINI);
        },
        sideBarToggleMobile({commit}) {
            commit(SIDEBAR_TOGGLE_MOBILE);
        }
    }
});

export default AppStore;